import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TDeleteCompanyTeamMemberRolesResponse = {
  readonly deletedRoleCount: number;
  readonly removedGuestEmployer: boolean;
  readonly removedAdminEmployer: boolean;
};

export const deleteCompanyTeamMemberRoles = (axios: IAxiosInstance) => {
  return async (options: {
    readonly companyId: string;
    readonly memberUserId: string;
  }) => {
    const { data } = await axios.noRetry.post<
      IApiResponse<TDeleteCompanyTeamMemberRolesResponse>
    >(`/api/companies/${options.companyId}/team-members/delete-member-roles`, {
      memberUserId: options.memberUserId,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to remove team member roles");
  };
};
